import React from 'react';
import PropTypes from 'prop-types';

import { Pending } from 'components/Icons';
import useWorkflowGuard from 'hooks/useWorkflowGuard';

const ManualAccountReview = ({ navigate, searchParams }) => {
  useWorkflowGuard(searchParams, navigate);

  return (
    <div className="flex flex-col items-center text-center mb-8">
      <Pending className="mb-4" variant="primary" />
      <p className="text-xl md:text-3xl font-semibold text-slate-800 mb-8">
        Bank Verification Pending
      </p>

      <div className="flex flex-col gap-4 text-sm md:text-base text-slate-600 px-0 md:px-[90px]">
        <p>Thank you for providing your bank statements. We are reviewing them and will update you regarding your offer as soon as possible.</p>
        <p>This process may take 2 to 5 days. We appreciate your patience.</p>
        <p>If you have any questions or concerns, please call <a  className="whitespace-nowrap text-blue-500 font-semibold" href="tel:+18447216961">(844) 721-6961</a>.</p>
      </div>
    </div>
  );
};

ManualAccountReview.propTypes = {
  navigate: PropTypes.func.isRequired,
  searchParams: PropTypes.object.isRequired,
};

export default ManualAccountReview;
